import { render, staticRenderFns } from "./FormularioAddTamizaje.vue?vue&type=template&id=293965f3&scoped=true"
import script from "./FormularioAddTamizaje.vue?vue&type=script&lang=js"
export * from "./FormularioAddTamizaje.vue?vue&type=script&lang=js"
import style0 from "./FormularioAddTamizaje.vue?vue&type=style&index=0&id=293965f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293965f3",
  null
  
)

export default component.exports